<template>
  <v-container fluid class="rv-duration-page">
    <!-- Filter (hidden — kept mounted so saved-view filterCondition still applies) -->
    <div class="rv-duration-filter-hidden" aria-hidden="true">
      <BreadTabulatorFilterable
        ref="filter"
        :model="model"
        :setConditions="setConditions"
      ></BreadTabulatorFilterable>
    </div>

    <!-- Search & Export Area -->
    <div class="rv-duration-search-area">
      <v-row align="center">
        <v-col md="6">
          <BreadTabulatorSearchable
            ref="search"
            :model="model"
            :setConditions="setConditions"
          ></BreadTabulatorSearchable>
          <div>
            <span id="record-count" class="rv-duration-record-count"></span>
          </div>
        </v-col>
        <v-col md="6" class="d-flex justify-end">
          <div class="rv-duration-export-wrap">
            <BreadTabulatorExportAll
              ref="exportData"
              :model="model"
              :apiUrl="apiGetBrowseUrl()"
              @downloadData="downloadData"
            >
            </BreadTabulatorExportAll>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Data Table -->
    <div class="rv-duration-table-wrapper">
      <BreadDataTable
        ref="tabulatorDataTable"
        layout="fitColumns"
        :autoColumns="false"
        :paginationSize="paginationSize"
        :paginationSizeSelector="paginationSizeSelector"
        :apiUrl="apiGetBrowseUrl()"
        :columns="columns"
        :modelKey="modelKey"
        :columnSelectionDisabledCount="columnSelectionDisabledCount"
        :responsiveLayout="false"
        @getCurrentPageSize="getCurrentPageSize"
        @getCurrentSort="getCurrentSort"
        @getCurrentColumnWidth="getCurrentColumnWidth"
        @getCurrentPageNumber="getCurrentPageNumber"
      ></BreadDataTable>
    </div>
  </v-container>
</template>
<script>
import Api from "@/objects/api";
import { mapState } from "vuex";
import Model from "@/objects/model";
import Service from "@/objects/service";

export default {
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
      hrdc: (state) => state.hrdc.data,
    }),
  },
  props: ["params"],
  data: () => ({
    api: new Api(),
    conditions: [],
    model: new Model(),
    service: new Service(),
    listAllViews: [],
    columns: [],
    paginationSize: 10,
    paginationSizeSelector: [10, 50, 100, 200],
    modelKey: "",
    parentId: "",
    cColumnSort: [],
    displayRowCount: 10,
    selectedCustomColums: [],
    selectedFilterConditions: [],
    allResizeColumns: [],
    columnSelectionDisabledCount: 2,
    currentPageNo: 1,
  }),
  created() {
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    this.modelKey = this.$route.params.modelKey;
    this.parentId = this.$route.params.parentId;

    this.columns = this.$_.filter(
      this.model.browse.table.headers,
      (headers) => {
        return headers;
      }
    );

    this.rolesAssignation(this.auth.roles);
  },
  mounted() {
    if (
      this.$route.query.viewId != "all" &&
      this.$route.query.viewId != "trashed"
    ) {
      const viewId = parseInt(this.$route.query.viewId, 10);
      this.getAllViews(viewId);
    }
    if (this.$route.query.viewId == "all") {
      this.getAllViews("all");
    }

    if (this.$route.query.viewId == "trashed") {
      this.getAllViews("trashed");
    }
  },
  methods: {
    getConditions() {
      return this.conditions;
    },
    setConditions(conditions) {
      this.selectedFilterConditions = conditions;
      this.conditions = conditions;
      this.$refs.tabulatorDataTable.getFilterCondition(conditions);
    },
    apiGetBrowseUrl() {
      let browseUrl = `${
        this.$service[this.service.key]
      }/v1/en/console/report/${this.model.child.durationAnalysisReport.key}`;

      // Check if user have salesperson role, then assign only this salesperson can see back own sales.
      if (this.isSalespersonRoles && this.auth.roles.length == 1) {
        browseUrl = browseUrl + `?email=${this.auth.email}`;
      }

      return browseUrl;
    },
    setFiltersViaConditions(conditions) {
      if (this.$refs.filter && this.$refs.filter.setFiltersViaConditions) {
        this.$refs.filter.setFiltersViaConditions(conditions);
      }
    },
    getCurrentPageSize(pagesize) {
      this.displayRowCount = pagesize;
    },
    getCurrentSort(sorters) {
      this.cColumnSort = sorters;
      this.cColumnSort = sorters.map((sorter) => {
        return {
          column: sorter.field,
          dir: sorter.dir,
        };
      });
    },
    getCurrentColumnWidth(resizedColumns) {
      const resizedColumnField = resizedColumns.getField();
      const resizedColumnWidth = resizedColumns.getWidth();

      //set the resized column width and filed name to the array
      const resizedColumnWidthAndField = {
        field: resizedColumnField,
        width: resizedColumnWidth,
      };

      const index = this.allResizeColumns.findIndex((item) => {
        return item.field === resizedColumnField;
      });

      if (index !== -1) {
        this.allResizeColumns[index].width = resizedColumnWidth;
      } else {
        this.allResizeColumns.push(resizedColumnWidthAndField);
      }
    },
    changeTableDetails(listAllViews, viewId) {
      // get the view details from listAllViews where id is equal to viewId
      if (viewId == "trashed") {
        //this.$refs.tabulatorDataTable.clearTableData();
        this.$refs.tabulatorDataTable.callApiUrl(this.apiGetBrowseTrashUrl());
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([]);
        this.$refs.search.getFilterCondition([]); /// add this one
        this.$refs.customView.changeSelectedTabStatus("trashed", 0);
      } else if (viewId == "all") {
        //this.$refs.tabulatorDataTable.clearTableData();
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([]);
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.search.getFilterCondition([]);
        this.$refs.customView.changeSelectedTabStatus("all", 1);
        this.setCurrentPageTo();
      } else {
        //console.log("other", this.$refs.tabulatorDataTable.getCurrentApiUrl());
        const tabIndex =
          listAllViews.indexOf(listAllViews.find((x) => x.id === viewId)) + 2;
        this.$refs.customView.changeSelectedTabStatus(viewId, tabIndex);
        const singleViewDetail = listAllViews.filter((item) => {
          return item.id === viewId;
        });

        if (singleViewDetail.length > 0) {
          if (
            JSON.parse(singleViewDetail[0].manageColumnCustomWidth).length > 0
          ) {
            this.$refs.tabulatorDataTable.callSavedHeaderWidth(
              JSON.parse(singleViewDetail[0].manageColumnCustomWidth)
            );
          }

          this.$refs.selectColumn.showViewSelectedColumns(
            JSON.parse(singleViewDetail[0].cColumnCondition)
          );

          // calling API
          if (JSON.parse(singleViewDetail[0].filterCondition).length > 0 && this.$refs.filter) {
            this.$refs.filter.setFiltersViaConditions(
              JSON.parse(singleViewDetail[0].filterCondition)
            );
          }

          // calling API
          if (JSON.parse(singleViewDetail[0].cColumnSort).length > 0) {
            this.$refs.tabulatorDataTable.callSavedColumnSort(
              JSON.parse(singleViewDetail[0].cColumnSort)
            );
          }

          // calling API
          if (singleViewDetail[0].displayRowCount != this.paginationSize) {
            this.$refs.tabulatorDataTable.callSavedPageSize(
              singleViewDetail[0].displayRowCount
            );
          }
          // add following one
          this.$refs.search.getFilterCondition(
            JSON.parse(singleViewDetail[0].filterCondition)
          );
        }

        this.setCurrentPageTo();
      }
    },
    getAllViews(viewId) {
      this.api.setMethod(`GET`);
      this.api.setUrl(
        `${this.$service.hrdc}/v1/en/console/crmView/list?modelKey=${this.model.key}`
      );
      this.api.setCallbackCompleted((response) => {
        // get all private views when the ouwnerUuid is equal to auth.uuid
        const privateViews = response.filter((view) => {
          return view.isPrivate === true && view.ownerUuid === this.auth.uuid;
        });

        // get all public views
        const publicViews = response.filter((view) => {
          return view.isPrivate === false;
        });

        // push all private and public views to listAllViews
        this.listAllViews = [...publicViews, ...privateViews];
        this.changeTableDetails(this.listAllViews, viewId);
      });
      this.api.fetch();
    },
    applyColumnSelection(selectedColumns) {
      this.selectedCustomColums = selectedColumns;
      this.$refs.tabulatorDataTable.applyColumnSelection(selectedColumns);
    },
    getCurrentPageNumber(pageno) {
      this.currentPageNo = pageno;
    },
    setCurrentPageTo() {
      var pageNo =
        this.$store.state.developer.data.paginationPageNo != null
          ? this.$store.state.developer.data.paginationPageNo
          : 1;
      this.$refs.tabulatorDataTable.tabulator.setPage(pageNo);
      this.$store.commit("assignDeveloperData", {
        paginationPageNo: null,
      });
    },
    downloadData(fileType, rowsType) {
      this.isLoading = true;

      switch (fileType) {
        case "csv":
          this.downloadCsvData(rowsType);
          break;
        case "xlsx":
          this.downloadExcelData(rowsType);
          break;
        case "pdf":
          this.downloadPdfData(rowsType);
          break;
        default:
          break;
      }
    },
    downloadCsvData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "csv",
        `${this.model.key}.csv`,
        {
          sheetName: `${this.model.key}`,
        },
        rowsType == "selected" ? "selected" : "all"
      );
      this.isLoading = false;
      // unchecked all the selected rows
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
  },
};
</script>
<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-duration-record-count {
  color: var(--app-text-muted);
}

.dark-mode .rv-duration-export-wrap >>> .v-btn {
  background: var(--app-card) !important;
}

.dark-mode .rv-duration-table-wrapper {
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE LAYOUT
   ============================================ */
.rv-duration-page {
  font-family: 'Lato', sans-serif;
  padding: 20px 24px !important;
}

/* Hidden filter — kept mounted so $refs.filter & saved-view filterCondition still work */
.rv-duration-filter-hidden {
  display: none !important;
}

/* ============================================
   SEARCH AREA
   ============================================ */
.rv-duration-search-area {
  margin-bottom: 16px;
}

.rv-duration-record-count {
  float: left;
  font-size: 0.75rem;
  color: #64748b;
  font-family: 'Lato', sans-serif;
}

/* ============================================
   EXPORT BUTTON (themed override)
   ============================================ */
.rv-duration-export-wrap >>> .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  height: 38px !important;
  padding: 0 18px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  color: #0ea5e9 !important;
  border: 1px solid rgba(14, 165, 233, 0.3) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.rv-duration-export-wrap >>> .v-btn:hover {
  background: #0ea5e9 !important;
  color: #ffffff !important;
  border-color: #0ea5e9 !important;
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.25) !important;
  transform: translateY(-1px);
}

.rv-duration-export-wrap >>> .v-btn:hover .v-icon {
  color: #ffffff !important;
}

.rv-duration-export-wrap >>> .v-btn .v-icon {
  color: #0ea5e9 !important;
  font-size: 18px !important;
}

.rv-duration-export-wrap >>> .v-btn::before {
  display: none;
}

/* ============================================
   TABLE WRAPPER
   ============================================ */
.rv-duration-table-wrapper {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03), 0 2px 8px rgba(0, 0, 0, 0.02);
  overflow: hidden;
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-duration-table-wrapper .tabulator {
  background: var(--app-card) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-header {
  background: var(--app-surface) !important;
  border-bottom: 1px solid var(--app-border) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col {
  background: var(--app-surface) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  color: var(--app-neutral-fg) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {
  background: var(--app-elevated) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder {
  background: var(--app-card) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table {
  background: var(--app-card) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row {
  border-bottom: 1px solid var(--app-border) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row:hover {
  background: var(--app-accent-soft) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
  color: var(--app-text) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selected {
  background: var(--app-accent-soft) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-footer {
  border-top: 1px solid var(--app-border) !important;
  color: var(--app-text-muted) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-paginator {
  color: var(--app-text-muted) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page-size {
  border: 1px solid var(--app-border) !important;
  background: var(--app-card) !important;
  color: var(--app-text) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page {
  border: 1px solid var(--app-border) !important;
  background: var(--app-card) !important;
  color: var(--app-neutral-fg) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page:hover:not(.disabled) {
  background: var(--app-accent-soft) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder::-webkit-scrollbar-track {
  background: var(--app-elevated);
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder::-webkit-scrollbar-thumb {
  background: var(--app-elevated);
}

.dark-mode .freeze-border-right {
  border-right: 1px solid var(--app-border-strong) !important;
}

.dark-mode .claim-basis-end-border-right {
  border-right: 2px solid var(--app-border-strong) !important;
}

.dark-mode .freeze-border-left {
  border-left: 1px solid var(--app-border-strong) !important;
}

/* >>> end auto-dark <<< */

/* ============================================
   TABULATOR OVERRIDES (unscoped for child)
   ============================================ */
.rv-duration-table-wrapper .tabulator {
  border: none !important;
  background: #ffffff !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.8rem !important;
}

/* ---------- Header ---------- */
.rv-duration-table-wrapper .tabulator .tabulator-header {
  background: #f8fafc !important;
  border: none !important;
  border-bottom: 1px solid #e2e8f0 !important;
  font-weight: 600 !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col {
  background: #f8fafc !important;
  border-right: 1px solid #eef2f7 !important;
  padding: 6px 4px !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col:last-child {
  border-right: none !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
  padding: 6px 8px !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  color: #475569 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.4px !important;
  line-height: 1.3 !important;
  white-space: normal !important;
  word-break: break-word !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {
  background: #eef2f7 !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="ascending"] .tabulator-col-content .tabulator-arrow,
.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="descending"] .tabulator-col-content .tabulator-arrow {
  border-color: transparent transparent #0ea5e9 !important;
}

/* ---------- Body rows ---------- */
.rv-duration-table-wrapper .tabulator .tabulator-tableholder {
  background: #ffffff !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table {
  background: #ffffff !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row {
  border: none !important;
  border-bottom: 1px solid #f1f5f9 !important;
  transition: background 0.15s ease;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-row-even {
  background: #fafbfc !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row:hover {
  background: #f0f9ff !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  color: #334155 !important;
  padding: 10px 12px !important;
  border-right: 1px solid #f5f7fa !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell:last-child {
  border-right: none !important;
}

/* Selected row */
.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selected {
  background: #e0f2fe !important;
}

/* ---------- Footer / pagination ---------- */
.rv-duration-table-wrapper .tabulator .tabulator-footer {
  background: #fafbfc !important;
  border-top: 1px solid #e2e8f0 !important;
  padding: 10px 14px !important;
  color: #64748b !important;
  font-size: 0.75rem !important;
  font-family: 'Lato', sans-serif !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-paginator {
  color: #64748b !important;
  font-family: 'Lato', sans-serif !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page-size {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  padding: 4px 10px !important;
  margin: 0 6px !important;
  background: #ffffff !important;
  color: #334155 !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  cursor: pointer;
  transition: all 0.15s ease;
}

.rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page-size:hover {
  border-color: #0ea5e9 !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  padding: 4px 10px !important;
  margin: 0 2px !important;
  background: #ffffff !important;
  color: #475569 !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  min-width: 32px;
  transition: all 0.15s ease;
}

.rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page:hover:not(.disabled) {
  background: #f0f9ff !important;
  border-color: #0ea5e9 !important;
  color: #0ea5e9 !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page.active {
  background: #0ea5e9 !important;
  border-color: #0ea5e9 !important;
  color: #ffffff !important;
  box-shadow: 0 2px 6px rgba(14, 165, 233, 0.25);
}

.rv-duration-table-wrapper .tabulator .tabulator-footer .tabulator-page.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ---------- Scrollbar ---------- */
.rv-duration-table-wrapper .tabulator .tabulator-tableholder::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 8px;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ---------- Legacy classes (kept for backwards compatibility) ---------- */
.freeze-border-right {
  border-right: 1px solid #cbd5e1 !important;
}
.claim-basis-end-border-right {
  border-right: 2px solid #94a3b8 !important;
}
.freeze-border-left {
  border-left: 1px solid #cbd5e1 !important;
}
</style>
